export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxJlkc6SjTjQJElg.7ce77422.woff2";